<template>
  <a-row type='flex'
         class="item">
    <a-col :span="2">
      <auto-icon :type='item.widgetSettings.icon' />
    </a-col>
    <a-col :span="8">
      <a-row class="title">
        {{ item.name }}
      </a-row>
      <a-row class="hint">
        {{ item.desc }}
      </a-row>
    </a-col>
    <a-col :span="10">
      <a-row class="title">
        {{ showValue }}
      </a-row>
    </a-col>
    <a-col :span="4">
      <a-row type='flex'
             justify='end'>
        <a-button type='link'
                  @click="onChange"
                  size='small'>{{ $t('system_config.SetDatetime.edit') }}</a-button>
      </a-row>
    </a-col>
    <!-- Modal -->
    <a-modal :title="`${$t('system_config.SetDatetime.edit')}${item.name}`"
             :width='520'
             v-model:visible="showModal"
             @ok="onChangeOk">
      <a-form ref="changeForm"
              :model="formState">
        <a-form-item :name='item.key'
                     :label="item.name"
                     :label-col="labelCol"
                     :rules="[
                       { required: true, message: `${$t('system_config.SetDatetime.set')}${item.name}` },
                     ]"
                     :wrapper-col="wrapperCol">
          <a-date-picker :placeholder="`${$t('system_config.SetDatetime.set')}${item.name}`"
                         v-model:value="formState[item.key]">
          </a-date-picker>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-row>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AutoIcon } from '@iota-cn/ui-components'
import { ref, computed, reactive } from 'vue'
import dayjs from 'dayjs'
import { useSysConfig } from '../../DefaultSystemPlugin'

const props = defineProps(['item'])
const labelCol = { span: 7 }
const wrapperCol = { span: 16 }
const showModal = ref(false)
const changeForm = ref()
const formState = reactive({
  [props.item.key]: dayjs(props.item.value || props.item.defaultValue)
})

const showValue = computed(() => {
  const v = props.item.value || props.item.defaultValue
  if (v) {
    return dayjs(v).format("YYYY-MM-DD HH:mm:ss")
  } else {
    return ''
  }
})

const onChange = () => {
  showModal.value = !showModal.value
  // changeForm.value.resetFields()
}

const sysConfig = useSysConfig()

const onChangeOk = () => {
  changeForm.value.validateFields().then((values: any) => {
    const value = values[props.item.key]
    // const value = values[props.item.key].format("YYYY-MM-DD HH:mm:ss")
    if (value === props.item.value) {
      showModal.value = false
      return
    }
    sysConfig.updateSysconfig({ key: props.item.key, value: value }).then(() => {
      showModal.value = false
    })
  }).catch(() => {
    return
  })
}
</script>

<style></style>